import React, { useCallback, useState } from 'react';
import { STEPS } from '@src/constants/instantVoiceCloning';
import { StyledVoiceCloneInput, Wrapper } from './index.style';
import Header from './Header';
import VoiceSampleUploader from './VoiceSampleUploader';
import PreviewAudio from './PreviewAudio';
import VoiceRecord from './VoiceRecord';

const VoiceCloneInput = ({ closePopupInstantVoiceCloning }) => {
  const [fileUpload, setFileUpload] = useState(null);
  const onSetFileUpload = useCallback(
    (file) => {
      setFileUpload(file);
    },
    [fileUpload],
  );

  const [step, setStep] = useState(STEPS.UPLOAD_AUDIO);
  const onSetStep = useCallback(
    (newStep) => {
      setStep(newStep);
    },
    [step],
  );

  const renderStep = () => {
    switch (step) {
      case STEPS.UPLOAD_AUDIO:
        return (
          <VoiceSampleUploader
            fileUpload={fileUpload}
            onSetFileUpload={onSetFileUpload}
            onSetStep={onSetStep}
          />
        );
      case STEPS.PREVIEW_AUDIO:
        return <PreviewAudio fileUpload={fileUpload} onSetStep={onSetStep} />;
      case STEPS.RECORD_AUDIO:
        return <VoiceRecord onSetStep={onSetStep} />;
      default:
        return null;
    }
  };

  return (
    <StyledVoiceCloneInput>
      <Wrapper>
        <Header closePopupInstantVoiceCloning={closePopupInstantVoiceCloning} />
        {renderStep()}
      </Wrapper>
    </StyledVoiceCloneInput>
  );
};
export default VoiceCloneInput;
